const device = {
  small: 'screen and (max-width: 500px)',
  medium: 'screen and (max-width: 768px)',
  large: 'screen and (max-width: 1024px)',
  xLarge: 'screen and (max-width: 1600px)',
};

const theme = {
  white: '#fff',
  black: '#222',
  navBlack: '#282828',
  mainBlue: '#5C7187',
  deepGray: '#494949',
  middleGray: '#7f7b7b',
  lightGray: '#babab8',

  mainBottomLine: '10px solid #7f7b7b',
  listBottomLine: '1px solid #7f7b7b',

  huge: '3.75rem',
  big: '3.125rem',
  xLarge: '1.875rem',
  large: '1.125rem',
  semiLarge: '1rem',
  medium: '0.938rem',
  semiMedium: '0.875rem',
  small: '0.75rem',
  xSmall: '0.625rem',

  bold: '700',
  normal: '500',
  light: '400',

  device,
};

export { theme };
